import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Text } from '../../../components/presentation/Text'
import { useSaveLevels } from './_requests/saveLevels'
import Button from '../../../components/actions/Button'
import FlexGrid from '../../../components/structure/FlexGrid'
import Separator from '../../../components/helpers/Separator'

const FooterBar = () => {
  const { t } = useTranslation()
  const [save, { loading, error }] = useSaveLevels()

  return (
    <div>
      <Separator weight={4} />
      <FlexGrid justify="space-between" gutter={0.2}>
        <Text color={COLORS.red}>{error}</Text>
        <Button loading={loading} onClick={save}>
          {t('save')}
        </Button>
      </FlexGrid>
    </div>
  )
}

export default FooterBar
